// src/components/Header.js
import React from 'react';
import '../styles/Header.css';

const Header = () => {
  return (
    <div className="header">
      <h1>DEF CON Glossary</h1>
      <h2><i>Your Source for Defcon Terminology: Term Meaning & Origin</i></h2>
    </div>
  );
};

export default Header;